/**
* Paroller (parallax)
*/
function fnParallax( i, oSection ) {

	var oSection 			= $( oSection );

	// Initiate paroller with default config
	$( oSection ).paroller({
        factor:         -0.075,
        type:           'foreground',
        direction:      'vertical'
    });

}


// END OF DOCUMENT
